module.exports = __webpack_public_path__ + "static/media/sign-out-alt.a7a76b47.svg";